module.exports = __webpack_public_path__ + "static/1-130e61f6c5ae7a3674a95a42ad955a26.jpg";